// Shared player-name normalizer for historical-team matching (#22).
//
// MUST be used identically by both the build-time generator
// (src/tools/genHistoricalTeams.js) and the runtime lookup
// (src/utils/historicalTeams.js join). Any divergence silently drops
// matches, so this lives in one place and is imported by both.
//
// Normalization: lowercase, strip accents, drop generational suffixes
// (Jr/Sr/II..V), remove punctuation, collapse whitespace. Mirrors the
// DynastyProcess `merge_name` convention so Yahoo/Sleeper display names
// ("Gardner Minshew II", "D.J. Moore") collapse to the same key as
// nflverse roster names.

export function normName(name) {
  if (!name) return "";
  return String(name)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")        // strip accents
    .replace(/[‘’']/g, "")          // apostrophes (curly + straight)
    .toLowerCase()
    .replace(/[.,]/g, "")                       // periods / commas
    .replace(/\b(jr|sr|ii|iii|iv|v)\b/g, "")  // generational suffixes
    .replace(/[^a-z0-9 ]/g, " ")               // any other punctuation -> space
    .replace(/\s+/g, " ")
    .trim();
}

// Fantasy skill position groups. nflverse / platform positions collapse to
// one of these; anything else (OL, DB, LB, team DEF, etc.) is not matched —
// team defenses don't have a team-by-season problem (the DEF *is* the team).
export function posGroup(pos) {
  if (!pos) return null;
  const p = String(pos).toUpperCase();
  if (p === "QB") return "QB";
  if (p === "RB" || p === "FB" || p === "HB") return "RB";
  if (p === "WR") return "WR";
  if (p === "TE") return "TE";
  if (p === "K" || p === "PK") return "K";
  return null;
}
